/**
 * Listen to event for when a user adds a wishlist item to their cart, we then
 * trigger an event in the Shopify theme to have the cart refresh.
 */
if(window.SwymCallbacks === undefined) {
    window.SwymCallbacks = [];
}
// Callback for when wishlist JS API is loaded
window.SwymCallbacks.push((swat) => {
    swat.evtLayer.addEventListener('sw:addedtocart', function(){
        console.log('added to cart!');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
        }));
    });
});
